import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const client = axios.create({ baseURL: API, withCredentials: true });

export function assetSrc(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return `${API}${url}`;
}

export function imageSrc(url) {
  return assetSrc(url);
}

export function photoSrc(url) {
  const src = assetSrc(url);
  if (!src || src.includes(`${process.env.REACT_APP_BACKEND_URL}/api/`)) return src;
  try {
    const parsed = new URL(src);
    if (parsed.hostname.includes("imgix.net")) {
      ["fit", "crop", "w", "h", "auto", "q", "dpr", "con", "sat"].forEach((key) => parsed.searchParams.delete(key));
      parsed.searchParams.set("fit", "crop");
      parsed.searchParams.set("crop", "focalpoint");
      parsed.searchParams.set("w", "1200");
      parsed.searchParams.set("h", "900");
      parsed.searchParams.set("auto", "format,compress");
      parsed.searchParams.set("q", "88");
      parsed.searchParams.set("dpr", "2");
      parsed.searchParams.set("con", "4");
      parsed.searchParams.set("sat", "6");
    }
    if (parsed.hostname.includes("unsplash.com")) {
      parsed.searchParams.set("auto", "format");
      parsed.searchParams.set("q", "92");
      parsed.searchParams.set("dpr", "2");
      parsed.searchParams.set("con", "4");
      parsed.searchParams.set("sat", "6");
      parsed.searchParams.set("fit", "crop");
      parsed.searchParams.set("crop", "focalpoint");
      parsed.searchParams.set("w", "1800");
      parsed.searchParams.set("h", "1500");
    }
    return parsed.toString();
  } catch {
    return src;
  }
}

export function mediaSrc(url) {
  return assetSrc(url);
}

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || String(item)).join(" ");
  return detail.msg || String(detail);
}
